// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-item__right[data-v-bdeb81f2] {\n  padding-right: 30px;\n}\n.collapsible-container[data-v-bdeb81f2] {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height ease-out 300ms;\n}\n.collapsible-container--expanded[data-v-bdeb81f2] {\n  max-height: 5000px;\n  transition: max-height ease-in 300ms;\n}", ""]);
// Exports
module.exports = exports;
